module.exports = __webpack_public_path__ + "img/undraw_confirmed.236d26ac.svg";